import { createRouter, createWebHistory } from "vue-router";

import ProjectsPage from "~/pages/ProjectsPage.vue";
import ProjectDetailPage from "~/pages/ProjectDetailPage.vue";
import JobRunsPage from "~/pages/JobRunsPage.vue";
import RunsPage from "~/pages/RunsPage.vue";

const routes = [
  { path: "/", redirect: "/projects" },
  { component: ProjectsPage, name: "projects", path: "/projects" },
  { component: ProjectDetailPage, name: "project", path: "/projects/:projectId", props: true },
  { component: JobRunsPage, name: "jobRuns", path: "/projects/:projectId/jobs/:jobId/runs", props: true },
  { component: RunsPage, name: "run", path: "/projects/:projectId/jobs/:jobId/runs/:runId", props: true }
];

export const router = createRouter({
  history: createWebHistory(),
  routes
});
